module.exports = __webpack_public_path__ + "static/img/material.6bf2eb0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material.gif
// module id = qj+T
// module chunks = 1